import React, { useEffect } from 'react';
import moment from 'moment';
import { NavLink } from 'react-router-dom';

import {
  ANALYTICS_CATEGORIES,
  ANALYTICS_ACTIONS,
  sendEvent,
} from '../../components/analytics';

import './style.scss';

const Race = (props) => {
  const {
    candidates = [],
    fetchRace,
    history,
    match: {
      params: {
        id: raceId,
      },
    },
    selectedElection,
    selectedRace,
    setSelectedCandidate,
  } = props;

  const onCandidateClick = (candidate) => {
    sendEvent(ANALYTICS_CATEGORIES.CANDIDATES, ANALYTICS_ACTIONS.SET);
    setSelectedCandidate(candidate._id);
    history.push(`/candidate/${candidate._id}?raceId=${raceId}`);
  };

  useEffect(() => {
    if (!selectedElection && !selectedRace) {
      fetchRace(raceId);
    }
  }, [selectedElection, selectedRace]);

  if (!selectedElection || !selectedRace) {
    return null;
  }

  const x = selectedRace.title;
  const removeAfter = x.split(':')[0];

  return (
    <div id="race-content">
      <h1>{selectedRace.title}</h1>
      <h3>{selectedElection.title}</h3>
      <h4>{moment(selectedElection.date).format('MMMM Do, YYYY')}</h4>
      <button id="race-to-quiz-button" type="button" onClick={() => history.push(`/quiz/${raceId}`)}>Trying to decide who to vote for? <strong>Take the quiz</strong> for this election</button>
      <div id="candidates-container">
        {candidates.map(candidate => (
          <div key={candidate._id}
            className="candidate"
            onClick={() => onCandidateClick(candidate)}
          >{candidate.name}
          </div>
        ))}
      </div>
      <button
        id="race-to-compare-candidates-button"
        type="button"
        onClick={() => history.push(`/compare-candidates/${raceId}`)}
      >Compare candidates by issue
      </button>
      <div className="separator-line" />
      <div id="role-link">
        {selectedRace && <p>Want to learn more about the role of a {removeAfter}?</p>}
        <NavLink className="link" to={`/roles/${removeAfter}`} exact>Explore Roles Here</NavLink>
      </div>
      <div id="add-container">
        <h3>Know of a candidate running for {selectedRace.title} that is not reported here?</h3>
        <p>Help us improve our application by providing information on it.</p>
        <button id="add-candidate-button" type="button" onClick={() => history.push(`/candidate/new?raceId=${raceId}`)}>Add Candidate To Race</button>
      </div>
    </div>
  );
};

export default Race;
